document.addEventListener("trix-initialize", function (event) {
    const toolbar = event.target.toolbarElement;
    const trixEditor = event.target;

    // Force text wrapping on the contenteditable element itself
    trixEditor.style.overflowX = 'hidden';
    trixEditor.style.overflowWrap = 'break-word';
    trixEditor.style.wordBreak = 'normal';
    trixEditor.style.whiteSpace = 'normal';

    // Add Sign on Glass button
    const signButton = document.createElement("button");
    signButton.type = "button";
    signButton.className = "trix-button";
    signButton.title = "Sign on Glass";
    signButton.innerHTML = "✍️";
    signButton.setAttribute("data-bs-toggle", "modal");
    signButton.setAttribute("data-bs-target", "#signatureModal");

    const blockGroup = toolbar.querySelector(".trix-button-group.trix-button-group--block-tools");
    if (blockGroup) {
        blockGroup.appendChild(signButton);
    }

    // Create image resize button group
    const resizeGroup = document.createElement("span");
    resizeGroup.className = "trix-button-group trix-button-group--image-tools";
    resizeGroup.style.display = "none";

    resizeGroup.innerHTML = `
        <button type="button" class="trix-button trix-button--icon-small" data-size="150" title="Small (150px)">S</button>
        <button type="button" class="trix-button trix-button--icon-medium" data-size="300" title="Medium (300px)">M</button>
        <button type="button" class="trix-button trix-button--icon-large" data-size="500" title="Large (500px)">L</button>
        <button type="button" class="trix-button trix-button--icon-original" data-size="auto" title="Original Size">100%</button>
    `;

    toolbar.appendChild(resizeGroup);

    let currentImage = null;

    resizeGroup.querySelectorAll('button').forEach(btn => {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            if (currentImage) {
                resizeImage(currentImage, this.dataset.size);
                highlightCurrentSize(resizeGroup, currentImage);
            }
        });
    });

    trixEditor.addEventListener('click', function(e) {
        if (e.target.tagName === 'IMG') {
            currentImage = e.target;
            resizeGroup.style.display = "";
            highlightCurrentSize(resizeGroup, currentImage);
        } else {
            currentImage = null;
            resizeGroup.style.display = "none";
        }
    });
});

// Helper function to get currently selected image
function getSelectedImage(editor) {
    const selectedRange = editor.getSelectedRange();
    if (!selectedRange) return null;

    const selectedAttachment = editor.getDocument().getAttachmentAtRange(selectedRange);
    if (!selectedAttachment) return null;

    const attachmentElement = document.querySelector(`[data-trix-attachment='${JSON.stringify(selectedAttachment.getAttributes())}']`);
    if (attachmentElement) {
        return attachmentElement.querySelector('img');
    }

    return null;
}

// Helper function to resize image
function resizeImage(img, size) {
    if (!img) return;

    if (size === 'auto') {
        img.style.width = 'auto';
        img.style.maxWidth = '100%';
    } else {
        img.style.width = size + 'px';
        img.style.maxWidth = size + 'px';
    }
    img.style.height = 'auto';
    img.style.transition = 'width 0.2s ease';
}

// Helper function to highlight current size button
function highlightCurrentSize(resizeGroup, img) {
    if (!img) return;

    const currentWidth = img.style.width;
    resizeGroup.querySelectorAll('button').forEach(btn => {
        btn.classList.remove('trix-active');
    });

    if (currentWidth === '150px') {
        resizeGroup.querySelector('[data-size="150"]')?.classList.add('trix-active');
    } else if (currentWidth === '300px') {
        resizeGroup.querySelector('[data-size="300"]')?.classList.add('trix-active');
    } else if (currentWidth === '500px') {
        resizeGroup.querySelector('[data-size="500"]')?.classList.add('trix-active');
    } else if (currentWidth === 'auto' || currentWidth === '') {
        resizeGroup.querySelector('[data-size="auto"]')?.classList.add('trix-active');
    }
}

// Optional: fallback manual modal close handlers
document.addEventListener("turbolinks:load", function () {
    const modal = document.getElementById("signatureModal");

    document.getElementById("closeModalBtn")?.addEventListener("click", () => {
        $(modal).modal("hide");
    });

    window.addEventListener("click", function (event) {
        if (event.target === modal) {
            $(modal).modal("hide");
        }
    });
});

document.addEventListener("trix-initialize", function () {
    const saveBtn = document.getElementById("save-signature");
    if (!saveBtn) return;

    saveBtn.addEventListener("click", function () {
        const canvas = document.getElementById("signature-pad");
        if (!canvas) return;

        const dataUrl = canvas.toDataURL("image/png");

        const trixEditor = document.querySelector("trix-editor");

        if (trixEditor) {
            const editor = trixEditor.editor;

            requestAnimationFrame(() => {
                const docLength = editor.getDocument().getLength();
                editor.setSelectedRange([docLength, docLength]);

                const attachment = new Trix.Attachment({
                    content: `<img src="${dataUrl}" alt="Signature" style="width: 300px; height: auto;" />`
                });

                editor.insertAttachment(attachment);
            });
        }

        const modalEl = document.getElementById("signatureModal");
        const modal = bootstrap.Modal.getInstance(modalEl);
        if (modal) modal.hide();

        const ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);
    });
});

// Universal image drop handler — initializes once per page lifecycle
(() => {
    if (window.__trixImageDropHandlerInitialized) return;
    window.__trixImageDropHandlerInitialized = true;

    let lastDrop = { editor: null, time: 0 };
    const DROP_WINDOW_MS = 1000;

    document.addEventListener(
        "drop",
        (e) => {
            const el = document.elementFromPoint(e.clientX, e.clientY);
            const editorEl = el && el.closest ? el.closest("trix-editor") : null;
            if (editorEl) {
                lastDrop = { editor: editorEl, time: performance.now() };
            }
        },
        true
    );

    const processedFiles = new WeakSet();

    function fileToDataURL(file) {
        return new Promise((resolve, reject) => {
            const r = new FileReader();
            r.onload = () => resolve(r.result);
            r.onerror = reject;
            r.readAsDataURL(file);
        });
    }

    document.addEventListener("trix-attachment-add", async (e) => {
        const attachment = e.attachment;
        const file = attachment?.file;
        if (!file || !file.type?.startsWith("image/")) return;

        if (processedFiles.has(file)) return;
        processedFiles.add(file);

        const editorEl = e.target;

        try {
            const dataUrl = await fileToDataURL(file);
            const token = document.querySelector('meta[name="csrf-token"]')?.content || "";
            const resp = await fetch("/azure_vision/analyze", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "X-CSRF-Token": token
                },
                body: JSON.stringify({ image: dataUrl })
            });

            const json = await resp.json().catch(() => ({}));

            if (resp.ok && json.text) {
                editorEl.editor.insertString(`\n\n[OCR]\n${json.text}\n\n`);
            } else if (resp.status === 403 && json.error) {
                alert(`❌ OCR Limit Reached\n\n${json.error}\n\nPlease visit your billing page to view your usage.`);
            } else if (json.error) {
                alert(`OCR Error: ${json.error}`);
            }
        } catch (err) {
            alert("Failed to perform OCR. Please try again.");
        }
    });

    document.addEventListener("trix-image-dropped", async (e) => {
        const { file, editor: editorEl } = e.detail;
        if (!file) return;

        const toDataURL = (blob) =>
            new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });

        try {
            const dataUrl = await toDataURL(file);
            const token = document.querySelector('meta[name="csrf-token"]')?.content || "";

            const resp = await fetch("/azure_vision/analyze", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "X-CSRF-Token": token
                },
                body: JSON.stringify({ image: dataUrl })
            });

            const json = await resp.json();
            if (!resp.ok) {
                if (resp.status === 403 && json.error) {
                    alert(`❌ OCR Limit Reached\n\n${json.error}\n\nPlease visit your billing page to view your usage.`);
                } else if (json.error) {
                    alert(`OCR Error: ${json.error}`);
                }
                return;
            }

            if (json.text) {
                editorEl.editor.insertString(`\n\n[OCR]\n${json.text}\n\n`);
            }
        } catch (err) {
            console.error("OCR request failed:", err);
        }
    });
})();
